import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth-context';
import { BOOKMARKS } from '@/constants/testIds';
import CharacterCard from '@/components/CharacterCard';
import { Loader2, BookmarkX } from 'lucide-react';

export default function Bookmarks() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { navigate('/login'); return; }
    api.get('/bookmarks')
      .then(({ data }) => setItems(data.items || []))
      .finally(() => setLoading(false));
  }, [user, authLoading, navigate]);

  if (loading || authLoading) {
    return (
      <div className="flex items-center justify-center py-32">
        <Loader2 className="w-6 h-6 text-slate-400 animate-spin" />
      </div>
    );
  }

  return (
    <div className="container-page py-12 lg:py-16" data-testid={BOOKMARKS.page}>
      <div className="mb-10">
        <h1 className="font-serif-display text-5xl text-slate-900 mb-2">Your Bookmarks</h1>
        <p className="text-slate-600">People you've saved for further study.</p>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-24 border border-dashed border-slate-200 rounded-xl">
          <BookmarkX className="w-8 h-8 text-slate-400 mx-auto mb-4" />
          <p className="font-serif-display text-2xl text-slate-700 mb-2">No bookmarks yet</p>
          <p className="text-sm text-slate-500 mb-6">Save people from their detail pages to revisit later.</p>
          <Link to="/" className="btn-primary text-sm py-2 px-4">Browse directory</Link>
        </div>
      ) : (
        <div data-testid={BOOKMARKS.list} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((c) => <CharacterCard key={c.id} character={c} />)}
        </div>
      )}
    </div>
  );
}
